document.addEventListener("DOMContentLoaded", function () {
  // Get references to the header and footer elements
  const header = document.getElementById("section-header");
  const footer = document.getElementById("section-footer");

  // Set a short delay before fading in (adjust the delay as needed)
  setTimeout(function () {
    header.style.opacity = "1";
    footer.style.opacity = "1";
  }, 500); // 1000 milliseconds (1 second) delay
});